module.exports = "/img/_/_/_/assets/images/creeper/battle/uncommon//26.jpg?0f486137032eb95bae7f1d6cc464c240";